import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Share } from "../model/share";
import { TimeSlotDialogComponent } from "../time-slot-dialog/time-slot-dialog.component";
import { FormControl } from "@angular/forms";

import { DateHelper } from "../util/dateHelper";
import { StringHelper } from "../util/stringHelper";
import { TimeSlotHelper } from "../util/timeSlotHelper";
// import { MessageHelperService } from '../service/message-helper.service';
import { UserService } from "../service/user.service";
import { Contact } from "../model/contact";
import { AddContactDialogComponent } from "../add-contact-dialog/add-contact-dialog.component";
import { GenericDialogComponent } from "../generic-dialog/generic-dialog.component";
import { Log } from "../util/log";
import { UserPermissions } from "../model/userPermissions";
import { UserPermissionsBuild } from "../model/userPermissionsBuild";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TimeSlot } from "../model/timeSlot";
import { DateAdapter } from "@angular/material/core";

@Component({
  selector: "app-device-permission-dialog-editor",
  templateUrl: "./device-permission-dialog-editor.component.html",
  styleUrls: ["./device-permission-dialog-editor.component.css"],
})
export class DevicePermissionDialogEditorComponent implements OnInit {
  previousPermissions: UserPermissions;

  fromFormControl: FormControl;
  toFormControl: FormControl;
  startDate: Date;
  expirationDate: Date;
  ownerUid: string;

  initialTimeSlots: TimeSlot[] = [];

  permissions: UserPermissions = new UserPermissions();
  allActions: any[] = [];
  allDays: boolean[] = [];

  showUsePreviousButton: boolean = false;

  error: boolean = false;
  errorMessage: String = "";

  constructor(
    public dialogRef: MatDialogRef<DevicePermissionDialogEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale($localize`:@@devicePermissions_dialog_datepicker_locale:it`);
    if (data.permissions != null) {
      this.permissions = UserPermissions.createCopy(data.permissions);

      if (!this.permissions.timeSlots) {
        this.permissions.timeSlots = TimeSlotHelper.binaryStringToTimeSlots(
          this.permissions.timeMask
        );
      } else {
        this.permissions.timeSlots = [];

        for (let slot of data.permissions.timeSlots) {
          this.permissions.timeSlots.push(Object.create(slot));
        }
      }

      this.fromFormControl = new FormControl(this.permissions.startDate);
      this.toFormControl = new FormControl(this.permissions.expirationDate);

      for (let i = 0; i < 7; i++) {
        this.allDays.push(this.permissions.isDayAllowed(i + 1));
      }
      this.startDate = DateHelper.parseDate(this.permissions.startDate);
      this.expirationDate = DateHelper.parseDate(
        this.permissions.expirationDate
      );
    } else {
      this.permissions = new UserPermissions();
      this.permissions.startDate = DateHelper.formatDateRFC3339(new Date());
      let oneMonthDate = new Date();
      oneMonthDate.setMonth(oneMonthDate.getMonth() + 1);
      this.permissions.expirationDate =
        DateHelper.formatDateRFC3339(oneMonthDate);
      this.permissions.dayMask = 127;
      for (let i = 0; i < 7; i++) {
        this.allDays.push(this.permissions.isDayAllowed(i + 1));
      }
      this.fromFormControl = new FormControl(this.permissions.startDate);
      this.toFormControl = new FormControl(this.permissions.expirationDate);
      this.permissions.timeSlots = [];
      this.permissions.timeMask = "111111111111111111111111111111111111111111111111";
      this.permissions.creatorUid = data.ownerUid;
      this.permissions.timeZone = "Europe/Rome";
    }

    if (data.previousPermissions) {

      this.showUsePreviousButton = true;
      this.previousPermissions = UserPermissions.createCopy(data.previousPermissions);
    }

    this.permissions.serial = data.serial;
    this.ownerUid = data.ownerUid;
  }

  ngOnInit() { }

  ngAfterInit() { }

  deleteTimeSlot(index: number) {
    this.permissions.timeSlots.splice(index, 1);
  }

  addTimeSlot() {
    let minPrecision = 30;
    const dialogRef = this.dialog.open(TimeSlotDialogComponent, {
      width: "450px",
      data: { minPrecision }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.permissions.timeSlots.push(result);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onDayChanged(day: number, event: any) {
    let value: boolean = event.target.checked;
    this.allDays[day - 1] = value;
  }

  saveShare() {
    let from: Date;
    if (this.fromFormControl.value) {
      from = new Date(this.fromFormControl.value);
    } else {
      from = new Date(this.permissions.startDate);
    }
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    from.setMilliseconds(0);

    let to: Date;
    if (this.toFormControl.value != null) {
      to = new Date(this.toFormControl.value);
    } else {
      to = new Date(this.permissions.expirationDate);
    }

    to.setHours(23);
    to.setMinutes(59);
    to.setSeconds(59);
    to.setMilliseconds(0);

    if (from >= to || to <= new Date()) {
      this.errorMessage = $localize`:@@devicePermissions_dialog_invalid_dates:Le date inserite non sono valide`;
      this.error = true;
      return;
    }

    if (to.getFullYear() > 2100) {
      this.errorMessage = $localize`:@@devicePermissions_dialog_over_2100:La data di scadenza non deve superare l'anno 2100`;
      this.error = true;
      return;
    }

    this.error = false;

    let permissionsToSave: UserPermissions = new UserPermissions();

    permissionsToSave.startDate = DateHelper.formatDateRFC3339(from);
    permissionsToSave.expirationDate = DateHelper.formatDateRFC3339(to);
    permissionsToSave.startDateDate = from;
    permissionsToSave.expirationDateDate = to;

    let timeMask: string = "000000000000000000000000000000000000000000000000";

    if (this.permissions.timeSlots.length > 0) {
      for (let i = 0; i < this.permissions.timeSlots.length; i++) {
        let timeSlotMask = TimeSlotHelper.timeSlotToBinaryString(
          this.permissions.timeSlots[i]
        );

        for (let j = 0; j < 48; j++) {
          if (timeSlotMask.charAt(j) == "1") {
            timeMask = StringHelper.replaceAt(timeMask, j, "1");
          }
        }
      }
    } else {
      timeMask = "111111111111111111111111111111111111111111111111";
    }

    permissionsToSave.timeMask = timeMask;

    let dayMask: number = 0;
    for (let i = 0; i < this.allDays.length; i++) {
      if (this.allDays[i]) {
        dayMask |= 1 << i;
      }
    }
    permissionsToSave.dayMask = dayMask;
    permissionsToSave.userOwnerId = this.permissions.userOwnerId;
    permissionsToSave.creatorUid = this.ownerUid;
    permissionsToSave.serial = this.permissions.serial;
    permissionsToSave.timeZone = this.permissions.timeZone;
    permissionsToSave.timeSlots = this.permissions.timeSlots;
    this.dialogRef.close({ permissions: permissionsToSave });
  }

  usePreviousPermissions() {
    let serialToSave = this.permissions.serial;
    this.permissions = UserPermissions.createCopy(this.previousPermissions);
    this.allDays = [];
    for (let i = 0; i < 7; i++) {
      this.allDays.push(this.permissions.isDayAllowed(i + 1));
    }
    this.fromFormControl.setValue(this.permissions.startDate);
    this.toFormControl.setValue(this.permissions.expirationDate);
    this.permissions.serial = serialToSave;
    this._snackBar.open($localize`:@@devicePermissions_dialog_permissions_applied:Permessi applicati`
      , $localize`:@@devicePermissions_dialog_close_toast:Chiudi`, { duration: 5000 });
  }
}
